"use client";

var _excluded = ["expanded"],
    _excluded2 = ["id", "url", "title", "icon", "targetBlank", "children"],
    _excluded3 = ["id", "url", "title", "targetBlank"],
    _excluded4 = ["id", "url", "title", "targetBlank"],
    _excluded5 = ["id", "url", "title"],
    _excluded6 = ["isOpen", "setIsOpen", "navLinks", "ribbonLinks", "hideQuoteButton", "quoteButtonUrl", "navSlot", "children"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20;

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React, { useState } from "react";
import styled from "styled-components";
import Expander from "@nib-components/expander";
import FocusTrap from "focus-trap-react";
import { focusOutlineColor, focusOutlineStyle, focusOutlineWidth, copyLineHeight, colorLightest, colorWhite, copyFontSizeSmall, linkLoud } from "@nib-components/theme";
import Overlay from "@nib-components/overlay";
import { CardSystemIcon, ChevronDownSystemIcon, CloseSystemIcon } from "@nib/icons";
import { Box, Columns, Column, Inline, Hidden, Padding, breakpoint, m, p, pl } from "@nib/layout";
import Link from "@nib-components/link";
import { UnstyledButton } from "@nib-components/button";
export var DrawerWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  height: 100%;\n  right: 3.5rem;\n  z-index: 11;\n  position: fixed;\n  top: 0;\n  left: 0;\n  overflow: auto;\n  transition: transform 0.3s ease-in-out;\n  transform: ", ";\n\n  ", "\n"])), colorWhite, function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? "translateX(0%)" : "translateX(-100%)";
}, breakpoint("xs", "md")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    right: 0;\n  "]))));
var ScreenReaderHiddenWhenClosed = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: ", ";\n"])), function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? "block" : "none";
});
export var InvisibleButton = styled(function (props) {
  return /*#__PURE__*/React.createElement(UnstyledButton, _extends({}, props, {
    padding: 4
  }));
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background: ", ";\n"])), colorWhite);
var DrawerOverlay = styled(Overlay)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  z-index: 9;\n"])));
export var HeaderLink = styled.a(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: bold;\n  text-decoration: none;\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: ", ";\n  }\n"])), linkLoud, focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineWidth);
export var DrawerHeader = styled(Columns)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  border-bottom: 1px solid ", ";\n"])), colorLightest);
var DrawerHeading = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  line-height: 1;\n"])));
export var QuoteIcon = styled(CardSystemIcon)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  vertical-align: sub;\n"])));
var ExpanderButton = styled(InvisibleButton)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  &&& {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    border: none;\n    background: none;\n    color: ", ";\n    ", ";\n    line-height: ", ";\n    transform: none !important; // this fixes the bug, but is a band-aid fix\n  }\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: -", ";\n  }\n"])), linkLoud, p(4), copyLineHeight, focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineWidth);
var Chevron = styled(function (_ref3) {
  var expanded = _ref3.expanded,
      otherProps = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/React.createElement(ChevronDownSystemIcon, otherProps);
})(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", ";\n  transition: transform 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53);\n"])), function (_ref4) {
  var expanded = _ref4.expanded;
  return expanded && "transform: rotate(180deg);";
});
var ExpanderContent = styled.ul(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  list-style: none;\n"])), m(0), p(0));
export var ExpanderLink = styled(Link).attrs({
  underline: false
})(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  &&& {\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    ", ";\n    text-align: left;\n    color: inherit;\n  }\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: -", ";\n  }\n"])), p(4), focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineWidth);
export var ExpanderSubLink = styled(ExpanderLink)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  ", ";\n"])), pl(6));
ExpanderSubLink.displayName = "ExpanderSubLink";
var RibbonLink = styled(Link)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  &&& {\n    color: inherit;\n    font-size: ", ";\n  }\n"])), copyFontSizeSmall);
RibbonLink.displayName = "RibbonLink";
export var DrawerExpander = function DrawerExpander(_ref5) {
  var link = _ref5.link,
      children = _ref5.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setExpanded = _useState2[1];

  var Icon = link.icon;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ExpanderButton, {
    title: link.title,
    "aria-expanded": isExpanded,
    "aria-haspopup": "true",
    onClick: function onClick() {
      return setExpanded(!isExpanded);
    }
  }, /*#__PURE__*/React.createElement(LineHeightZeroInline, {
    space: 4,
    verticalAlign: "center"
  }, Icon ? /*#__PURE__*/React.createElement(Icon, {
    size: "md"
  }) : "", /*#__PURE__*/React.createElement(DrawerHeading, null, link.title)), /*#__PURE__*/React.createElement(Chevron, {
    expanded: isExpanded
  })), /*#__PURE__*/React.createElement(Expander, {
    expanded: isExpanded,
    "aria-label": link.title
  }, /*#__PURE__*/React.createElement(ExpanderContent, null, children)));
};
DrawerExpander.displayName = "DrawerExpander";
export var DrawerMenu = styled.ul(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", ";\n  ", ";\n  list-style: none;\n"])), m(0), p(0));
export var MenuItem = styled.li(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n\n  &:not(:first-of-type) {\n    border-top: 1px solid ", ";\n  }\n\n  &:last-of-type {\n    border-bottom: 1px solid ", ";\n  }\n"])), colorLightest, colorLightest);
export var MenuLink = styled.a(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  appearance: none;\n  border: none;\n  background: none;\n\n  display: flex;\n  align-items: center;\n  width: 100%;\n  position: relative;\n  ", ";\n  text-decoration: none;\n  color: ", ";\n  font-weight: bold;\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: -", ";\n  }\n"])), p(4), linkLoud, focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineWidth);
var LineHeightZeroInline = styled(Inline)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  line-height: 0;\n"])));
var LineHeightOneInline = styled(Inline)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  line-height: 1;\n"])));

var DrawerContent = function DrawerContent(_ref6) {
  var navLinks = _ref6.navLinks,
      ribbonLinks = _ref6.ribbonLinks,
      navSlot = _ref6.navSlot,
      children = _ref6.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DrawerMenu, null, navLinks && navLinks.length > 0 && navLinks.filter(function (link) {
    return !link.hideInDrawer;
  }).map(function (link) {
    var id = link.id,
        url = link.url,
        title = link.title,
        icon = link.icon,
        targetBlank = link.targetBlank,
        children = link.children,
        otherProps = _objectWithoutProperties(link, _excluded2);

    var Icon = icon;
    return link.children ? /*#__PURE__*/React.createElement(MenuItem, {
      key: id
    }, /*#__PURE__*/React.createElement(DrawerExpander, {
      link: link
    }, url && /*#__PURE__*/React.createElement("li", {
      key: "".concat(id, "-mobile")
    }, /*#__PURE__*/React.createElement(ExpanderLink, _extends({
      id: "".concat(id, "-mobile"),
      title: title,
      href: url,
      target: targetBlank ? "_blank" : "",
      rel: targetBlank ? "noopener noreferrer" : ""
    }, otherProps), title)), children && children.map(function (child) {
      var id = child.id,
          url = child.url,
          title = child.title,
          targetBlank = child.targetBlank,
          otherProps = _objectWithoutProperties(child, _excluded3);

      return /*#__PURE__*/React.createElement("li", {
        key: "".concat(id, "-mobile")
      }, /*#__PURE__*/React.createElement(ExpanderLink, _extends({
        id: "".concat(id, "-mobile"),
        title: title,
        href: url,
        target: targetBlank ? "_blank" : "",
        rel: targetBlank ? "noopener noreferrer" : ""
      }, otherProps), title), child.children && /*#__PURE__*/React.createElement(DrawerMenu, null, child.children && child.children.map(function (subChild) {
        var id = subChild.id,
            url = subChild.url,
            title = subChild.title,
            targetBlank = subChild.targetBlank,
            otherProps = _objectWithoutProperties(subChild, _excluded4);

        return /*#__PURE__*/React.createElement("li", {
          key: "".concat(id, "-mobile")
        }, /*#__PURE__*/React.createElement(ExpanderSubLink, _extends({
          id: "".concat(id, "-mobile"),
          title: title,
          href: url,
          target: targetBlank ? "_blank" : "",
          rel: targetBlank ? "noopener noreferrer" : ""
        }, otherProps), /*#__PURE__*/React.createElement(Inline, {
          verticalAlign: "center",
          space: 2
        }, /*#__PURE__*/React.createElement(Hidden, {
          screenReader: true
        }, /*#__PURE__*/React.createElement(Box, {
          color: "dark"
        }, "\u2014")), /*#__PURE__*/React.createElement("span", null, title))));
      })));
    }))) : /*#__PURE__*/React.createElement(MenuItem, {
      key: id
    }, /*#__PURE__*/React.createElement(MenuLink, _extends({
      id: "".concat(id, "-mobile"),
      title: title,
      href: url,
      target: targetBlank ? "_blank" : "",
      rel: targetBlank ? "noopener noreferrer" : "",
      key: "".concat(id, "-mobile")
    }, otherProps), /*#__PURE__*/React.createElement(LineHeightZeroInline, {
      space: 4,
      verticalAlign: "center"
    }, Icon ? /*#__PURE__*/React.createElement(Icon, {
      size: "md"
    }) : "", /*#__PURE__*/React.createElement(LineHeightOneInline, null, /*#__PURE__*/React.createElement("span", null, title)))));
  }), navSlot && /*#__PURE__*/React.cloneElement(navSlot, {
    isInDrawer: true
  })), ribbonLinks && ribbonLinks.length > 0 && /*#__PURE__*/React.createElement(Padding, {
    all: 4
  }, /*#__PURE__*/React.createElement(Inline, {
    space: 3
  }, ribbonLinks.map(function (link, i) {
    var id = link.id,
        url = link.url,
        title = link.title,
        otherProps = _objectWithoutProperties(link, _excluded5);

    return /*#__PURE__*/React.createElement(RibbonLink, _extends({
      id: "".concat(id, "-mobile"),
      key: "item-".concat(i, "-").concat(id, "-mobile"),
      href: url,
      title: title
    }, otherProps), title);
  }))), children && /*#__PURE__*/React.createElement(Box, {
    padding: 4
  }, children));
};

DrawerContent.displayName = "DrawerContent";

var Drawer = function Drawer(_ref7) {
  var _ref7$isOpen = _ref7.isOpen,
      isOpen = _ref7$isOpen === void 0 ? false : _ref7$isOpen,
      setIsOpen = _ref7.setIsOpen,
      navLinks = _ref7.navLinks,
      ribbonLinks = _ref7.ribbonLinks,
      hideQuoteButton = _ref7.hideQuoteButton,
      quoteButtonUrl = _ref7.quoteButtonUrl,
      navSlot = _ref7.navSlot,
      children = _ref7.children,
      otherProps = _objectWithoutProperties(_ref7, _excluded6);

  var defaultedQuoteUrl = quoteButtonUrl ? quoteButtonUrl : "/health-insurance/quote/welcome";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DrawerOverlay, {
    visible: isOpen
  }), /*#__PURE__*/React.createElement(FocusTrap, {
    active: isOpen,
    focusTrapOptions: {
      clickOutsideDeactivates: true,
      onDeactivate: function onDeactivate() {
        return setIsOpen(false);
      }
    }
  }, /*#__PURE__*/React.createElement(DrawerWrapper, _extends({
    isOpen: isOpen
  }, otherProps), /*#__PURE__*/React.createElement(ScreenReaderHiddenWhenClosed, {
    isOpen: isOpen
  }, /*#__PURE__*/React.createElement(DrawerHeader, null, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Box, {
    padding: 4,
    display: "flex",
    justifyContent: "center"
  }, !hideQuoteButton && /*#__PURE__*/React.createElement(HeaderLink, {
    id: "ga-nav-hi-quote-mobile",
    href: defaultedQuoteUrl,
    "aria-label": "Get a quote"
  }, /*#__PURE__*/React.createElement(Inline, {
    space: 2,
    align: "center"
  }, /*#__PURE__*/React.createElement(QuoteIcon, null), /*#__PURE__*/React.createElement("span", null, "Get a quote"))))), /*#__PURE__*/React.createElement(Column, {
    width: "content"
  }, /*#__PURE__*/React.createElement(InvisibleButton, {
    onClick: function onClick() {
      return setIsOpen(false);
    },
    "aria-label": "Close menu"
  }, /*#__PURE__*/React.createElement(CloseSystemIcon, null)))), /*#__PURE__*/React.createElement(DrawerContent, {
    navLinks: navLinks,
    ribbonLinks: ribbonLinks,
    navSlot: navSlot
  }, children)))));
};

Drawer.displayName = "Drawer";
Drawer.DrawerWrapper = DrawerWrapper;
Drawer.DrawerMenu = DrawerMenu;
export default Drawer;